"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePetsData = exports.petsFormRules = exports.petsFieldMapping = exports.petsSchema = void 0;
const converters_1 = require("../converters");
exports.petsSchema = {
    fields: {
        applicant_pet_name: {
            maxLength: 50,
        },
        applicant_pet_color: {
            maxLength: 20,
        },
        applicant_pet_breed: {
            maxLength: 50,
        },
        applicant_pet_weight: {
            pattern: /^\d+$/,
            maxLength: 10,
        },
        applicant_pet_age: {
            pattern: /^\d+$/,
        },
        applicant_pet_gender: {
        // No specific validation rules
        },
        applicant_pet_spayed_or_neutered: {
        // No specific validation rules
        },
        applicant_pet_date_spayed_or_neutered: {
            custom: {
                validate: (value) => {
                    if (!value)
                        return true; // Allow empty since it's not required
                    const inputDate = new Date(value);
                    const today = new Date();
                    today.setHours(23, 59, 59, 999); // Set to end of today
                    return inputDate <= today;
                },
                message: 'Spay/neuter date must be today or in the past',
            },
        },
        applicant_pet_date_rabies_shot: {
            custom: {
                validate: (value) => {
                    if (!value)
                        return true; // Allow empty since it's not required
                    const inputDate = new Date(value);
                    const today = new Date();
                    today.setHours(23, 59, 59, 999); // Set to end of today
                    return inputDate <= today;
                },
                message: 'Rabies shot date must be today or in the past',
            },
        },
        applicant_pet_license_number: {
        // No specific validation rules
        },
        applicant_pet_license_city: {
        // No specific validation rules
        },
        applicant_pet_house_broken: {
        // No specific validation rules
        },
    },
    messages: {
        applicant_pet_name: {
            required: 'Pet name is required',
            maxLength: 'Pet name must be 50 characters or less',
        },
        applicant_pet_color: {
            maxLength: 'Pet color must be 20 characters or less',
        },
        applicant_pet_breed: {
            required: 'Pet breed is required',
            maxLength: 'Pet breed must be 50 characters or less',
        },
        applicant_pet_weight: {
            pattern: 'Pet weight must be a valid number',
            maxLength: 'Pet weight must be 10 characters or less',
        },
        applicant_pet_age: {
            pattern: 'Pet age must be a valid number',
        },
        applicant_pet_date_spayed_or_neutered: {
            custom: 'Spay/neuter date must be today or in the past',
        },
        applicant_pet_date_rabies_shot: {
            custom: 'Rabies shot date must be today or in the past',
        },
    },
};
// Field mapping between DTO naming and UI naming
exports.petsFieldMapping = {
    applicant_pet_assistance_animal: 'applicant_pet_assistance_animal',
    applicant_pet_name: 'applicant_pet_name',
    applicant_pet_color: 'applicant_pet_color',
    applicant_pet_breed: 'applicant_pet_breed',
    applicant_pet_weight: 'applicant_pet_weight',
    applicant_pet_age: 'applicant_pet_age',
    applicant_pet_gender: 'applicant_pet_gender',
    applicant_pet_spayed_or_neutered: 'applicant_pet_spayed_or_neutered',
    applicant_pet_date_spayed_or_neutered: 'applicant_pet_date_spayed_or_neutered',
    applicant_pet_date_rabies_shot: 'applicant_pet_date_rabies_shot',
    applicant_pet_license_number: 'applicant_pet_license_number',
    applicant_pet_license_city: 'applicant_pet_license_city',
    applicant_pet_house_broken: 'applicant_pet_house_broken',
};
// 🚀 Pre-computed validations for performance
exports.petsFormRules = (0, converters_1.toReactHookForm)(exports.petsSchema, exports.petsFieldMapping);
exports.validatePetsData = (0, converters_1.createValidator)(exports.petsSchema);
